import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    minWidth: 500,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 0,
    width: 300,
  },
  menuButton:{
    margin:5
  },
});

const initialState = {
  oldPassword: "",
  newPassword: "",
  retypeNewPassword: ""
};

class UserManage extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  componentWillMount(){
    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );
  }

  handleChange = (event, key) => {
    this.setState({
      [key] : event.target.value
    });

  }

  changePasswoerd = () => {
    const { enqueueSnackbar } = this.props;
    this.authApi.changePassword(this.state.oldPassword, this.state.newPassword)
      .then(response => {

        if(response.code){
          if(response.code === "NotAuthorizedException"){
            enqueueSnackbar('現在のパスワードが間違っています。', {variant : 'error'});
          }

          if(response.code === "InvalidParameterException"){
            enqueueSnackbar('パスワードは８文字以上で、大文字、小文字を含んで設定してください。', {variant : 'error'});
          }

          if(response.code === "InvalidPasswordException"){
            enqueueSnackbar('パスワードは８文字以上で、大文字、小文字を含んで設定してください。', {variant : 'error'});
          }

          if(response.code === "LimitExceededException"){
            enqueueSnackbar('失敗回数が規定の回数を超えました。しばらくたってからお試しください。', {variant : 'error'});
          }
        }else{
          enqueueSnackbar('パスワードを変更しました。', {variant : 'success'});
        }

        this.setState({
          ...initialState
        })

      })

  }

  render() {
    const {classes} = this.props
    const {
      oldPassword,
      newPassword,
      retypeNewPassword
    } = this.state;

    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        if (value !== this.state.newPassword) {
            return false;
        }
        return true;
    })

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              ユーザ管理
            </Typography>
          </Grid>
          <Grid item>
            <Paper className={classes.root} elevation={1}>
              <Typography variant="h6" gutterBottom>
                パスワード変更
              </Typography>
              <ValidatorForm
                ref="form"
                onSubmit={() => this.changePasswoerd()}
                onError={
                  errors => {
                    console.log(errors);
                    const { enqueueSnackbar } = this.props;
                    enqueueSnackbar('任意の項目が不正です', {variant : 'warning'});
                  }
                }
              >
                <TextValidator
                  className={classes.textField}
                  name="oldPassword"
                  label="現在のパスワード"
                  value={oldPassword}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'oldPassword')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  type="password"
                  style={{marginTop: 30}}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="newPassword"
                  label="新しいパスワード"
                  value={newPassword}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'newPassword')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  type="password"
                  style={{marginTop: 30}}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="retypeNewPassword"
                  label="新しいパスワード(確認)"
                  value={retypeNewPassword}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'retypeNewPassword')}
                  required={true}
                  validators={['required', 'isPasswordMatch']}
                  type="password"
                  errorMessages={['必須項目を入力してください', '新しいパスワードが一致しません']}
                />

                <Button type="submit" variant="contained" color="default" className={classes.button} style={{marginLeft:"85%", marginTop:20}}>
                  変更
                </Button>
              </ValidatorForm>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

UserManage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(UserManage)));
